onComplete(function() {
	var header = document.querySelector('.nav-header');

	// The header only gets its shadow once content scrolls underneath it, so it reads as flat on top of the hero.
	if (header) {
		var updateHeader = function() {
			header.classList.toggle('is-scrolled', window.scrollY > 8);
		};

		updateHeader();
		window.addEventListener('scroll', updateHeader, { passive: true });
	}

	// Editors must always see every block, and visitors who prefer reduced motion get no animation at all.
	var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	var editorMode = document.body.hasAttribute('data-editor-mode');

	if (reduceMotion || editorMode || !('IntersectionObserver' in window)) {
		return;
	}

	var groups = [
		'.content-subtemplate-home .content-split .module-output-split > *',
		'.items-overview > .container > [data-partial="text"]',
		'.items-overview .row > [class*="col-"]',
		'.kweek-section .kweek-section-image',
		'.kweek-section .kweek-section-content',
		'.image-text-section .unclamp-left-clamp-right > *',
		'.content-subtemplate-content .first-content section.output-left-media-right .row > *',
		'.content-center-section .container > [data-partial="partial-list"]',
		'.iconic-usps .container > [data-partial="text"]',
		'.iconic-usps .iconic-usps-block',
		'.text-media-section .row > *',
		'.media-text-section .row > *',
		'.contact-template-content .row > *',
		'footer .top .row > *'
	];

	var observer = new IntersectionObserver(function(entries) {
		entries.forEach(function(entry) {
			if (entry.isIntersecting) {
				entry.target.classList.add('is-visible');
				observer.unobserve(entry.target);
			}
		});
	}, { rootMargin: '0px 0px -10% 0px' });

	groups.forEach(function(selector) {
		// Counted per parent, so a section further down the page starts without delay instead of waiting behind the sections above it.
		var counters = new Map();

		document.querySelectorAll(selector).forEach(function(element) {
			var index = counters.get(element.parentElement) || 0;
			counters.set(element.parentElement, index + 1);

			// Siblings in the same group fade in one after another instead of all at once.
			element.style.setProperty('--reveal-delay', Math.min(index, 4) * 120 + 'ms');
			element.classList.add('reveal');
			observer.observe(element);
		});
	});

	// The hidden start state is only applied once JavaScript is sure to reveal the elements again.
	document.documentElement.classList.add('has-reveal');


});

